import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Loading } from "../../components";
import { ApiHelper, DateHelper, EnvironmentHelper, FeedInterface } from "../../helpers";


interface Props {
  shape: string
}


export const NewPlaylistType: React.FC<Props> = props => {

  const [feeds, setFeeds] = React.useState<FeedInterface[]>(null);

  const init = () => {
    ApiHelper.get("/feeds/public").then((data: FeedInterface[]) => {
      const result: FeedInterface[] = [];
      data.forEach(d => {
        if (d.shapes.indexOf(props.shape) > -1) result.push(d);
      });
      setFeeds(result)
    });
  }

  React.useEffect(init, [props.shape])

  const getExternalLink = () => {
    return (<Col sm={6} md={4} xl={3}>
      <Link to="/playlists/0?mode=externalFeed">
        < img src="/images/externalfeed.png" alt="thumbnail" />
        <span>External Feed</span>
      </Link>
    </Col >);
  }

  const getSlideshowLink = () => {
    return (<Col sm={6} md={4} xl={3}>
      <Link to="/playlists/0?mode=slideshow">
        < img src="/images/slideshow.png" alt="thumbnail" />
        <span>Slideshow</span>
      </Link>
    </Col >);
  }


  const getFeeds = () => {
    if (!feeds) return <Loading />
    else {
      const result: JSX.Element[] = [];
      feeds?.forEach(f => {
        const thumbPath = EnvironmentHelper.ContentRoot + "/feeds/" + f.id + "/thumb.png?modified=" + DateHelper.convertToDate(f.lastModified).getTime();
        let url = "/settings/feeds/" + f.id;
        if (props.shape !== "16:9") url += "?shape=" + props.shape;
        result.push(<Col key={"f" + f.id} sm={6} md={4} xl={3}>
          <Link to={url}>
            <img src={thumbPath} alt="thumbnail" />
            <span>{f.name}</span>
          </Link>
        </Col>);
      });
      return (<><h4>Or Select a Feed</h4><div id="designerList" className="row condensed">{result}{getSlideshowLink()}{getExternalLink()}</div></>);
    }
  }

  return (<>
    <Row>
      <Col md={4}>
        <Link className="btn btn-success btn-lg btn-block" style={{ marginTop: 15, marginBottom: 15 }} to={"/playlists/0?shape=" + props.shape}><i className="fas fa-list-ul"></i> Create a New Custom Playlist</Link>
      </Col>
    </Row>
    <hr />
    {getFeeds()}
  </>);


};